import { extendTheme } from "@chakra-ui/react";
import foundationsColors from "./Foundations/colors";
import tokensColors from "./Tokens/colors";
import fonts from "./Foundations/fonts";
import Button from "./Components/Button";
import Input from "./Components/Input";
import Select from "./Components/Select";
import Table from "./Components/Table";

export const theme = extendTheme({
  colors: {
    ...foundationsColors,
    ...tokensColors,
  },
  fonts,
  styles: {
    global: {
      body: {
        bg: "neutrals.background.weak-50",
        color: "neutrals.text.strong-950",
        fontFamily: "body",
      },
    },
  },
  components: {
    Button,
    Input,
    Select,
    Table,
  },
});
